// Self-hosted brand logos for the MCP catalog: each service's own publicly-published site icon,
// committed under ./logos so tiles render reliably from our own domain with no runtime third-party
// call or rate limit. Fetched once at build time (see the logos/ folder). vite emits each file as a
// hashed static asset (assetsInlineLimit: 0), so this adds files, not bundle weight. Keyed by the
// domain in the catalog's `logo:<domain>:<letter>` marker; BrandGlyph falls back to the letter if a
// domain has no file.
const modules = import.meta.glob('./logos/*', { eager: true, query: '?url', import: 'default' });

// Used verbatim: in built output renderBuiltUrl (relative) already resolves these against the importing
// chunk, so any prefix corrupts an absolute STATIC_URL; in dev the vite server serves the raw path.
export const MCP_LOGOS: Record<string, string> = Object.fromEntries(
  Object.entries(modules).map(([path, url]) => [
    path
      .split('/')
      .pop()!
      .replace(/\.[^.]+$/, ''),
    url as string,
  ]),
);
